import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TSubmitPersonaVerification,
  TSubmitPersonaVerificationResponse,
} from "./submitPersonaVerification.schema";

export const submitPersonaVerification = (axios: IAxiosInstance) => {
  return async (
    body: TSubmitPersonaVerification
  ): Promise<TSubmitPersonaVerificationResponse> => {
    const response = await axios.noRetry.post<
      ZealApiResponse<TSubmitPersonaVerificationResponse>
    >("/api/submitPersonaVerification", {
      workerType: body.workerType,
      personaInquiryId: body.personaInquiryId,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
